import {
  GetUserOrdersDetailsWithFiltersResponseType,
  UserOrderDetailsFilterType
} from '@nw/shared/data-access';

import { UserOrdersDetailsModel } from '../models/UserOrdersModel';

export interface TransformedUserOrdersData {
  userOrders: UserOrderDetailsFilterType[];
}

/**
 * Transform API response to UserOrdersDetailsModel
 * Maps the new filtered user orders API response to the model
 */
export const userOrdersDetailsTransformer = (
  data: GetUserOrdersDetailsWithFiltersResponseType
): UserOrdersDetailsModel => {
  const transformedData: TransformedUserOrdersData = {
    userOrders: data.user_orders || []
  };

  return new UserOrdersDetailsModel(transformedData);
};
